module.exports = __webpack_public_path__ + "static/media/docker.20654ab9.jpg";